export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/currency.37005859.svg","height":22,"width":21,"blurWidth":0,"blurHeight":0};